import React, { useEffect } from 'react';
import {ISearchFilter, ISearchFilterOption} from '../../../../../context/search/types';
import useSearch from '../../../../../context/search/useSearch';
import FilterDisplayTypes from '../FilterDisplayTypes/FilterDisplayTypes';

interface IMultiOptionFilter {
  filterIndex: number,
  filter: ISearchFilter,
}

const MultiOptionFilter: React.FC<IMultiOptionFilter> = ({filterIndex, filter}): JSX.Element => {

  const { inputEventHandlers, filtersChanged, markFiltersChanged } = useSearch()

  useEffect(() => {
    //on close apply filters if they have changed
    if (!filter.open && filtersChanged) {
      inputEventHandlers.handleApply()
    }
  }, [filter.open])

  if (!filter.open) return <></>

  return (
    <>
      <div className={`filter__options filter__options--multi filter__options--${filter.displayType.toLowerCase()}`}>
        <div className={`filter__items filter__items--${filter.label} filter__items--box filter__items--${filter.displayType.toLowerCase()}`}>
          {
            (filter.options as ISearchFilterOption[]).map((option, index) => {
              const disabled = option.records < 1 && !option.selected;
              return (
                <label className={`filter__option filter__option--multi  ${option.selected ? 'filter__option--selected' : ''} ${disabled ? 'filter__option--disabled' : ''} filter__option--${filter.displayType.toLowerCase()}`} key={index}>
                  <input onChange={() => {
                    inputEventHandlers.handleToggleMultiOption(filterIndex, index)
                    markFiltersChanged()
                  }}
                  checked={option.selected}
                  className="visually-hidden"
                  disabled={disabled}
                  type="checkbox"
                  />
                  <FilterDisplayTypes option={option} displayType={filter.displayType} />
                </label>
              )
            })}
        </div>
      </div>
    </>
  )
}

export default MultiOptionFilter